import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { CommPlanDetail } from 'src/app/models/commission/comm-plan-detail.model';
import { CommissionService } from 'src/app/service/commission.service';
import { NotificationService } from 'src/app/service/notification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-commission-plan',
  templateUrl: './commission-plan.component.html',
  styleUrls: ['./commission-plan.component.css']
})

export class CommissionPlanComponent implements OnInit {
  getImageData: CommPlanDetail[] = [];
  imgStr: SafeResourceUrl;

  constructor(private _location: Location, private _sanitizer: DomSanitizer, private commissionService: CommissionService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.getImage();
  }

  backClicked() {
    this._location.back();
  }

  getImage() {
    console.log(localStorage.getItem('commplan'));
    console.log(localStorage.getItem('SESSION_EFFDATE'));
    this.commissionService.getImage(localStorage.getItem('commplan'), localStorage.getItem('SESSION_EFFDATE'))
      .subscribe((data: CommPlanDetail[]) => {
        this.getImageData = data;
        console.log(this.getImageData);

        for (let imgData of this.getImageData) {
          console.log(imgData);
          this.imgStr = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
            + encodeURI(imgData.comm_img_str));
          console.log(this.imgStr);
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

}

